import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = ({ temperature = 'Loading...' }) => {
    const [offcanvasOpen, setOffcanvasOpen] = useState(false);
    const [searchPopupOpen, setSearchPopupOpen] = useState(false);

    const toggleOffcanvas = () => setOffcanvasOpen(!offcanvasOpen);
    const closeOffcanvas = () => setOffcanvasOpen(false);

    const toggleSearchPopup = () => setSearchPopupOpen(!searchPopupOpen);
    const closeSearchPopup = () => setSearchPopupOpen(false);

    return (
        <>
            {/* ===== Scroll to top ===== */}
            <div className="progress-wrap progress-wrap_4">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                </svg>
            </div>

            {/* ===== OFFCANVAS – with inline styles ===== */}
            <div className="fix">
                {/* The offcanvas panel */}
                <div
                    className={`offcanvas__area ${offcanvasOpen ? 'open' : ''}`}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '320px',
                        maxWidth: '80%',
                        height: '100%',
                        zIndex: 9999,
                        background: '#fff',
                        transform: offcanvasOpen ? 'translateX(0)' : 'translateX(-100%)',
                        transition: 'transform 0.3s ease-in-out',
                        overflowY: 'auto',
                        boxShadow: '2px 0 10px rgba(0,0,0,0.2)',
                        padding: '20px',
                    }}
                >
                    <div className="offcanvas__wrapper">
                        <div className="offcanvas__content">
                            {/* Top: logo + close button */}
                            <div className="offcanvas__top d-flex justify-content-between align-items-center">
                                <div className="offcanvas__logo">
                                    <Link to="/" onClick={closeOffcanvas}>
                                        <img src="assets/img/logo/logo2025_2.png" alt="logo" style={{ maxWidth: '150px' }} />
                                    </Link>
                                </div>
                                <div className="offcanvas__close">
                                    <button
                                        className="offcanvas-close-icon animation--flip"
                                        onClick={closeOffcanvas}
                                        style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}
                                    >
                                        ✕
                                    </button>
                                </div>
                            </div>

                            {/* ===== MOBILE MENU ===== */}
                            <div className="mobile-menu mean-container_4 fix" style={{ marginTop: '30px' }}>
                                <nav>
                                    <ul style={{ listStyle: 'none', padding: 0 }}>
                                        <li className="active">
                                            <Link to="/" onClick={closeOffcanvas} style={{ display: 'block', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                                Home
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/about" onClick={closeOffcanvas} style={{ display: 'block', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                                About Us
                                            </Link>
                                        </li>
                                        <li className="has-dropdown">
                                            <a href="#" style={{ display: 'block', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                                News <i className="fa fa-angle-down" />
                                            </a>
                                            <ul className="sub-menu" style={{ paddingLeft: '20px', listStyle: 'none' }}>
                                                <li>
                                                    <Link to="/venkatadri-allnews-details" onClick={closeOffcanvas} style={{ display: 'block', padding: '8px 0' }}>
                                                        Thirumala & Thirupathi News
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/bengaluru-allnews-details" onClick={closeOffcanvas} style={{ display: 'block', padding: '8px 0' }}>
                                                        Bengaluru News
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/karnataka-allnews-details" onClick={closeOffcanvas} style={{ display: 'block', padding: '8px 0' }}>
                                                        Karnataka News
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/national-allnews-details" onClick={closeOffcanvas} style={{ display: 'block', padding: '8px 0' }}>
                                                        National News
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>


                                        <li>
                                            <Link to="#" onClick={closeOffcanvas} style={{ display: 'block', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                                Membership
                                            </Link>
                                        </li>



                                        <li>
                                            <Link to="#" onClick={closeOffcanvas} style={{ display: 'block', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                                Thirupathi Darshan
                                            </Link>
                                        </li>


                                        <li>
                                            <Link to="/contact" onClick={closeOffcanvas} style={{ display: 'block', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                                                Contact
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                            {/* Social Icons */}
                            <div className="offcanvas__social offcanvas__social_4" style={{ marginTop: '30px' }}>
                                <h3 className="offcanvas__title mb-20 text-black">Subscribe &amp; Follow</h3>
                                <ul style={{ display: 'flex', gap: '15px', listStyle: 'none', padding: 0 }}>
                                    <li>
                                        <a href="#" target="_blank" rel="noopener noreferrer">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" target="_blank" rel="noopener noreferrer">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Overlay – also with inline styles */}
                <div
                    className={`offcanvas__overlay ${offcanvasOpen ? 'active' : ''}`}
                    onClick={closeOffcanvas}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(0,0,0,0.5)',
                        zIndex: 9998,
                        opacity: offcanvasOpen ? 1 : 0,
                        visibility: offcanvasOpen ? 'visible' : 'hidden',
                        transition: 'opacity 0.3s ease, visibility 0.3s ease',
                        cursor: 'pointer',
                    }}
                />
                {/* Additional overlay if needed – you can remove if not used */}
                <div
                    className={`offcanvas__overlay-white ${offcanvasOpen ? 'active' : ''}`}
                    onClick={closeOffcanvas}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 9997,
                        opacity: offcanvasOpen ? 0.3 : 0,
                        visibility: offcanvasOpen ? 'visible' : 'hidden',
                        transition: 'opacity 0.3s ease, visibility 0.3s ease',
                        background: '#fff', // optional
                        pointerEvents: 'none',
                    }}
                />
            </div>

            {/* ===== HEADER (unchanged except for the hamburger button) ===== */}
            <header className="header__area header-2 header-3 header-4">
                {/* Top header – same as before */}
                <div className="header__top">
                    <div className="container custom-container">
                        <div className="row align-items-center">
                            <div className="col-lg-10">
                                <div className="header-3__top-left">
                                    <div className="header-3__cat">
                                        <div className="header-3__item"><span /><Link to="/bengaluru-allnews-details"><button>Bengalauru News</button></Link></div>
                                        <div className="header-3__item"><span /><Link to="/national-allnews-details"><button>National News</button></Link></div>
                                        <div className="header-3__item"><span /><Link to="/world"><button>World</button></Link></div>
                                        <div className="header-3__item"><span /><Link to="/entertainment"><button>Entertainment News</button></Link></div>

                                        <div className="header-3__item"><span /><Link to="/life-style"><button>Lifestyle</button></Link></div>
                                        <div className="header-3__item"><span /><Link to="/health"><button>Health</button></Link></div>
                                        <div className="header-3__item"><span /><Link to="/sport"><button>Sport</button></Link></div>
                                        <div className="header-3__item"><span /><Link to="/tech"><button>Technology</button></Link></div>
                                        <div className="header-3__item"><span /><Link to="/food"><button>Food</button></Link></div>
                                        <div className="header-3__item"><span /><Link to="/environment"><button>Environment</button></Link></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2">
                                <div className="header__top-right">
                                    <div className="header__social">
                                        <span>Follow Us:</span>
                                        <ul>
                                            <li><a href="#" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f" /></a></li>
                                            <li><a href="#" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram" /></a></li>
                                            <li><a href="#" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube" /></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>









                <div className="header__wrap header-sticky">
                    {/* Marquee */}
                    <marquee
                        behavior="scroll"
                        direction="left"
                        loop="infinite"
                        scrollamount={5}
                        onMouseOver={(e) => e.currentTarget.stop()}
                        onMouseOut={(e) => e.currentTarget.start()}
                        style={{ background: '#3d2d5e', color: '#ffffff', padding: '10px', fontSize: '18px', fontWeight: 'bold' }}
                    >
                        {/* Duplicate the link 3 times to fill the gap longer */}
                        <a href="#" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'none', marginRight: '50px' }}>
                            Welcome to Venkatadri Weekly News Paper
                        </a>
                        <a href="#" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'none', marginRight: '50px' }}>
                            Welcome to Venkatadri Weekly News Paper
                        </a>
                        <a href="#" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'none', marginRight: '50px' }}>
                            Welcome to Venkatadri Weekly News Paper
                        </a>
                        <a href="#" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'none', marginRight: '50px' }}>
                            Welcome to Venkatadri Weekly News Paper
                        </a>
                    </marquee>

                    <div className="container custom-container">
                        <div className="header__main">
                            <div
                                className="header-4__location d-none d-md-flex"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "15px",
                                    padding: "10px 15px",
                                    background: "#fff",
                                    borderRadius: "15px",
                                    boxShadow: "0 4px 15px rgba(0,0,0,0.08)"
                                }}
                            >
                                <Link to="/contact">
                                    <img
                                        src="assets/img/team/nagabhushan.jpeg"
                                        alt="Nagabhushan J"
                                        style={{
                                            width: "70px",
                                            height: "70px",
                                            objectFit: "cover",
                                            borderRadius: "15px",
                                            flexShrink: 0
                                        }}
                                    />
                                </Link>

                                <div style={{ flex: 1 }}>
                                    <h5
                                        style={{
                                            margin: 0,
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            color: "#222"
                                        }}
                                    >
                                        Nagabhushan
                                    </h5>

                                    <p
                                        style={{
                                            margin: "4px 0",
                                            fontSize: "12px",
                                            color: "#666",
                                            lineHeight: "1.5"
                                        }}
                                    >
                                        B.Com., LL.B., PGDBA., PGDCA., ICWA (Inter)
                                    </p>



                                    <p
                                        style={{
                                            margin: "4px 0",
                                            fontSize: "12px",
                                            color: "#666"
                                        }}
                                    > Editor-In-Chief</p>

                                    <p
                                        style={{
                                            margin: "4px 0",
                                            fontSize: "12px",
                                            color: "#666"
                                        }}
                                    >

                                        karnatakapolicenews@gmail.com
                                    </p>


                                </div>
                            </div>

                            <div className="header__logo text-center">
                                <Link to="/">
                                    <img src="assets/img/logo/logo2025_2.png" alt="Logo" className="img-fluid" />
                                </Link>
                            </div>



                            <div className="header__right d-flex align-items-center">
                                <div className="header__btn d-none d-sm-block editor-card">
                                    <span>{temperature}</span>
                                    <p>Bengaluru</p>
                                </div>
                                {/* ===== HAMBURGER BUTTON – visible on mobile ===== */}
                                <div className="header__menu-toggle d-lg-none">
                                    <button className="menu-toggle sidebar__toggle" onClick={toggleOffcanvas}>
                                        <span /><span /><span />
                                    </button>



                                </div>
                            </div>
                        </div>
                        <div className="header-4__location d-lg-none mobile-editor editor-card">
                            <Link to="/contact">
                                <img
                                    src="assets/img/team/nagabhushan.jpeg"
                                    alt="Nagabhushan J"
                                    className="editor-img"
                                />
                            </Link>

                            <div className="editor-info">
                                <h5>Nagabhushan</h5>
                                <p className="qualification">
                                    B.Com., LL.B., PGDBA., PGDCA., ICWA (Inter)
                                </p>
                                <p className="qualification">Editor-In-Chief</p>
                                <p className="qualification">
                                    karnatakapolicenews@gmail.com
                                </p>

                            </div>
                        </div>
                    </div>

                    {/* Bottom Navigation – desktop only */}
                    <div className="header-4__wrap-bottom d-none d-lg-block" style={{ background: '#000000 ', color: '#ffffff' }}>
                        <div className="container custom-container">
                            <div className="header-4__main">
                                <div className="header__menu__wrapper d-none d-lg-flex align-items-center">
                                    <div className="header__menu-toggle d-none d-lg-flex">
                                        <button className="menu-toggle sidebar__toggle" onClick={toggleOffcanvas}>
                                            <span /><span /><span />
                                        </button>
                                    </div>
                                    <div className="main-menu">
                                        <nav id="mobile-menu">
                                            <ul>
                                                <li className="active"><Link to="/">Home</Link></li>
                                                <li><Link to="/about">About Us</Link></li>
                                                <li className="has-dropdown">
                                                    <a href="#">News <i className="fa fa-angle-down" /></a>
                                                    <ul className="sub-menu">
                                                        <li><Link to="/venkatadri-allnews-details">Thirumala & Thirupathi News</Link></li>
                                                        <li><Link to="/bengaluru-allnews-details">Bengaluru News</Link></li>
                                                        <li><Link to="/karnataka-allnews-details">Karnataka News</Link></li>
                                                        <li><Link to="/national-allnews-details">National News</Link></li>
                                                    </ul>
                                                </li>
                                                <li><Link to="#">Membership</Link></li>

                                                <li><Link to="#">Thirupathi Darshan</Link></li>


                                                <li><Link to="/contact">Contact</Link></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                <div className="header__right d-flex">
                                    <div className="header__discount d-none d-sm-block">
                                        <Link to="/contact">For Advertise With Us <span>Contact</span></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header >

            {/* ===== Search Popup (unchanged) ===== */}
            < div className={`search__popup ${searchPopupOpen ? 'active' : ''}`
            }>
                <div className="container">
                    <div className="row gx-30">
                        <div className="col-xxl-12">
                            <div className="search__wrapper">
                                <div className="search__top d-flex justify-content-between align-items-center">
                                    <div className="search__logo">
                                        <Link to="/"><img src="assets/img/logo/logo2025_2.png" alt="icon" /></Link>
                                    </div>
                                    <div className="search__close">
                                        <button type="button" className="search__close-btn search-close-btn" onClick={closeSearchPopup}>
                                            <svg width={18} height={18} viewBox="0 0 18 18" fill="none">
                                                <path d="M17 1L1 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M1 1L17 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div className="search__form">
                                    <form action="#" onSubmit={(e) => e.preventDefault()}>
                                        <div className="search__input">
                                            <input className="search-input-field" type="text" placeholder="Type here to search..." />
                                            <span className="search-focus-border" />
                                            <button type="submit">
                                                <svg width={20} height={20} viewBox="0 0 20 20" fill="none">
                                                    <path d="M9.55 18.1C14.272 18.1 18.1 14.272 18.1 9.55C18.1 4.82797 14.272 1 9.55 1C4.82797 1 1 4.82797 1 9.55C1 14.272 4.82797 18.1 9.55 18.1Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M19.0002 19.0002L17.2002 17.2002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default Header;